"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useItemDetail = void 0;
var react_1 = __importDefault(require("react"));
var useItemDetail = function () {
    var _a = __read(react_1.default.useState(), 2), currentItem = _a[0], setCurrentItem = _a[1];
    // Generalized update function for currentItem
    var updateItem = function (key, value) {
        setCurrentItem(function (prevItem) {
            var _a;
            if (!prevItem)
                return prevItem;
            // Use type assertion here
            return __assign(__assign({}, prevItem), (_a = {}, _a[key] = value, _a));
        });
    };
    // Specific update functions utilizing the generalized update function
    var updateItemCurrent = function (newCurrent) {
        updateItem('ad', __assign(__assign({}, currentItem === null || currentItem === void 0 ? void 0 : currentItem.ad), { current: newCurrent }));
    };
    var updateItemCustomerSpecific = function (newCustomerSpecific) {
        updateItem('ad', __assign(__assign({}, currentItem === null || currentItem === void 0 ? void 0 : currentItem.ad), { customerSpecific: newCustomerSpecific }));
    };
    var updateItemFeedback = function (feedback) {
        var feedbackIds = feedback.map(function (f) { return f.feedbackId; });
        updateItem('selectedFeedback', feedback);
        updateItem('selectedFeedbackIds', feedbackIds);
    };
    var updateModerationNotes = function (notes) {
        updateItem('moderationNotes', { notes: notes, failedToLoad: false, loading: false });
    };
    var onSelectDecision = function (decision) {
        updateItem('selectedDecision', decision);
        if (decision.queue) {
            updateItem('routingQueueObj', decision.queue);
        }
    };
    return {
        currentItem: currentItem,
        setCurrentItem: setCurrentItem,
        updateItemCurrent: updateItemCurrent,
        updateItemCustomerSpecific: updateItemCustomerSpecific,
        updateItemFeedback: updateItemFeedback,
        updateModerationNotes: updateModerationNotes,
        onSelectDecision: onSelectDecision,
    };
};
exports.useItemDetail = useItemDetail;
